/*Layout */
import Layout from '@/layout'
import Vue from 'vue'
import Router from 'vue-router'
/*Router Modules */

Vue.use(Router)

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/common-page/redirect')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/common-page/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/common-page/error-page/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/meet'
  },
  {
    path: '/profile',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        component: () => import('@/views/profile'),
        name: 'Profile',
        meta: { title: '个人中心', icon: 'user', noCache: true }
      }
    ]
  }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  {
    path: '/meet',
    component: Layout,
    redirect: '/meet/order',
    name: 'meet',
    meta: { title: '会议室', icon: 'info' },
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/meet/order'),
        meta: { title: '预 订', icon: 'info', roles: ['admin', 'editor'] }
      },
      //{
      //path: 'manage',
      //name: 'manage',
      //component: () => import('@/views/meet/manage'),
      //meta: { title: '管 理', icon: 'info', roles: ['admin', 'editor'] }
      //},
      {
        path: 'config',
        name: '配置',
        component: () => import('@/views/meet/config'),
        meta: { title: '配 置', icon: 'info', roles: ['admin'] }
      }
    ]
  },
  //{
  //path: '/libary',
  //component: Layout,
  //redirect: '/libary/sort',
  //name: 'InfoLibary',
  //children: [
  //{
  //path: 'sort',
  //name: 'Sort',
  //component: () => import('@/views/Libary/sort'),
  //meta: { title: '菜品分类', icon: 'sort', roles: ['admin', 'editor'] }
  //},
  //]
  //},
  /**when your routing map is too long, you can split it into small modules **/
  {
    path: '/error',
    component: Layout,
    redirect: 'noRedirect',
    name: 'ErrorPages',
    meta: {
      title: 'Error Pages',
      icon: '404'
    },
    hidden: true,
    children: [
      {
        path: '401',
        component: () => import('@/views/common-page/error-page/401'),
        name: 'Page401',
        meta: { title: '401', noCache: true }
      },
      {
        path: '404',
        component: () => import('@/views/common-page/error-page/404'),
        name: 'Page404',
        meta: { title: '404', noCache: true }
      }
    ]
  },
  //404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  //mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

//Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher //reset router
}

export default router
